import React from "react";
import logo from "../../img/logo-conga.svg";
// import logo from "../../img/logo-conga.png";
import { withRouter } from "react-router-dom";
import { version, RELEATIVE_PATH } from "../../config";
import "./push-upgrade-header.css";

const CommomLogo = (props) => {
  let removePath = props.location.pathname.replace(RELEATIVE_PATH, "");
  let title = removePath.replace(/\//g, " ");
  title=title.split(' ')[0];
  title = title.includes("upgrade-status") ? "upgrade-status" : title;
  return (
    <>
    {title==="demo"?<></>:
     <div id="commonLogo">
       <img  src={logo} />
       <div className="header-text-center header-text-font">
        <div>Conga Automation Platform</div>  
        <div className="ver">4.02</div>
       </div>
       

     </div>}
    </>
  );
};
export default withRouter(CommomLogo);
